import React from 'react'

import bg1 from '../../assets/images/counter.jpg'
import { counterData } from '../../data/startup'

import CountUp from 'react-countup';

export default function CtaOne() {
  return (
    <section className="section" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
    <div className="bg-overlay"></div>
    <div className="container">
        <div className="row" id="counter">
            {counterData.map((item,index)=>{
                return(
                    <div className="col-md-3 col-6" key={index}>
                        <div className="counter-box py-4 text-center">
                            <i className={`text-light title-dark h1 ${item.icon}`}></i>
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp className="counter-value" end={item.target} />+</h2>
                            <h6 className="counter-head text-light title-dark">{item.title}</h6>
                        </div>
                    </div>
                )
            })}
        </div>
    </div>
</section>
  )
}
